import type { Idea } from '@qlk/shared';

export interface TheGoiYProps {
  yTuong: Idea[];
}

/** Ba thẻ gợi ý dưới bảng Kanban, theo ảnh docs/design/san-xuat.png. */
export function TheGoiY({ yTuong }: TheGoiYProps) {
  const thiTruong = [...new Set(yTuong.map((y) => y.market))].join(' / ') || 'EN / PT / VI';

  const the = [
    {
      tieuDe: 'Kho ý tưởng & từ khóa',
      mo: `Ý tưởng theo chủ đề, độ cạnh tranh từ khóa và video tham chiếu cho thị trường ${thiTruong}.`,
    },
    {
      tieuDe: 'Chọn nhạc từ kho',
      mo: 'Gợi ý nhạc Miss Records hoặc kho hợp tác theo mood, BPM và thời lượng; chặn bài hết hạn hoặc kênh chưa whitelist.',
    },
    {
      tieuDe: 'Mẫu metadata',
      mo: 'Tiêu đề, mô tả, tag, chapter và dòng credit nhạc tự điền theo từng kênh.',
    },
  ];

  return (
    <div className="mt-6 grid grid-cols-1 gap-4 @min-[800px]/noi-dung:grid-cols-3">
      {the.map((t) => (
        <section key={t.tieuDe} className="rounded-the border border-vien bg-be-mat p-6">
          <h2 className="text-tieu-de-khoi font-semibold text-chu">{t.tieuDe}</h2>
          <p className="mt-2 text-co-ban text-chu-phu">{t.mo}</p>

          {t.tieuDe === 'Kho ý tưởng & từ khóa' && yTuong.length > 0 && (
            <ul className="mt-3 space-y-1.5 text-phu text-chu-phu">
              {yTuong.slice(0, 3).map((y) => (
                <li key={y.id} className="flex items-start gap-2">
                  <span className="so-lieu mt-0.5 shrink-0 rounded-full bg-neutral-nen px-1.5 text-chu">
                    {y.market}
                  </span>
                  <span className="min-w-0 truncate">{y.topic}</span>
                </li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}
